import PaxelRecycleMeta from './routes/meta/PaxelRecycleMeta.vue';
import PaxelRecycleBanner from './routes/banner/PaxelRecycleBanner.vue';
import PaxelRecycleReason from './routes/reason/PaxelRecycleReason.vue';
import createPaxelRecycleReason from './routes/reason/component/createPaxelRecycleReason.vue';
import editPaxelRecycleReason from './routes/reason/component/editPaxelRecycleReason.vue';
import PaxelRecycleWasteType from './routes/waste_type/PaxelRecycleWasteType.vue';
import createPaxelRecycleWasteType from './routes/waste_type/component/createPaxelRecycleWasteType.vue';
import editPaxelRecycleWasteType from './routes/waste_type/component/editPaxelRecycleWasteType.vue';
import PaxelRecycleBeforeSending from './routes/before_sending/PaxelRecycleBeforeSending.vue';
import PaxelRecycleHowTo from './routes/how_to/PaxelRecycleHowTo.vue';
import createPaxelRecycleHowTo from './routes/how_to/component/createPaxelRecycleHowTo.vue';
import editPaxelRecycleHowTo from './routes/how_to/component/editPaxelRecycleHowTo.vue';
import PaxelRecycleTutorial from './routes/tutorial/PaxelRecycleTutorial.vue';
import PaxelRecycleCoverage from './routes/coverage/PaxelRecycleCoverage.vue';
import PaxelRecycleMoreInfo from './routes/more_info/PaxelRecycleMoreInfo.vue';

const PaxelRecycleRoutes = [
  {
    path: '/paxel-recycle-meta',
    name: 'PaxelRecycleMeta',
    component: PaxelRecycleMeta,
  },
  {
    path: '/paxel-recycle-banner',
    name: 'PaxelRecycleBanner',
    component: PaxelRecycleBanner,
  },
  {
    path: '/paxel-recycle-reason',
    name: 'PaxelRecycleReason',
    component: PaxelRecycleReason,
  },
  {
    path: '/create-paxel-recycle-reason',
    name: 'createPaxelRecycleReason',
    component: createPaxelRecycleReason,
  },
  {
    path: '/edit-paxel-recycle-reason/:id',
    name: 'editPaxelRecycleReason',
    component: editPaxelRecycleReason,
  },
  {
    path: '/paxel-recycle-waste-type',
    name: 'PaxelRecycleWasteType',
    component: PaxelRecycleWasteType,
  },
  {
    path: '/create-paxel-recycle-waste-type',
    name: 'createPaxelRecycleWasteType',
    component: createPaxelRecycleWasteType,
  },
  {
    path: '/edit-paxel-recycle-waste-type/:id',
    name: 'editPaxelRecycleWasteType',
    component: editPaxelRecycleWasteType,
  },
  {
    path: '/paxel-recycle-before-sending',
    name: 'PaxelRecycleBeforeSending',
    component: PaxelRecycleBeforeSending,
  },
  {
    path: '/paxel-recycle-how-to',
    name: 'PaxelRecycleHowTo',
    component: PaxelRecycleHowTo,
  },
  {
    path: '/create-paxel-recycle-how-to',
    name: 'createPaxelRecycleHowTo',
    component: createPaxelRecycleHowTo,
  },
  {
    path: '/edit-paxel-recycle-how-to/:id',
    name: 'editPaxelRecycleHowTo',
    component: editPaxelRecycleHowTo,
  },
  {
    path: '/paxel-recycle-tutorial',
    name: 'PaxelRecycleTutorial',
    component: PaxelRecycleTutorial,
  },
  {
    path: '/paxel-recycle-coverage',
    name: 'PaxelRecycleCoverage',
    component: PaxelRecycleCoverage,
  },
  {
    path: '/paxel-recycle-more-info',
    name: 'PaxelRecycleMoreInfo',
    component: PaxelRecycleMoreInfo,
  },
];

export default PaxelRecycleRoutes;